define([
  "client/template",
  "utils/persistedsourceinfo",
  "model/persisted_collection",
  "service/stub",
  "client/application",
  "backbone",
  "underscore",
  "jquery",
  "i18n/i18n",
  "api/v2/common",
  "api/v2/persisted",
  "service/channel",
  "service/channels",
  "api/v2/resources",
  "client/resourceinfo"
], function(
  Template,
  PersistedSourceInfo,
  PersistedCollection,
  Stub,
  Application,
  Backbone,
  _,
  $,
  i18n,
  Common,
  Persisted,
  Channel,
  Channels,
  Resources,
  ResourceInfo
) {

  var PreviewFeedbackModel = Backbone.Model.extend({

    toJSON: function() {
      var atts = this.attributes;
      var path = atts.path;

      return {
        path: path,
        data: JSON.stringify(atts.data),
        property: atts.property
      };
    }

  });
  var PreviewFeedbackCollection = PersistedCollection.extend({

    model: PreviewFeedbackModel,
    usePaths: true,

    initialize: function (unused, options) {
      options = options || {};
      options.serviceStub = options.serviceStub || new Stub({path: "persistedresources"}); //persistedcollections
      PersistedCollection.prototype.initialize.apply(this, arguments);
      this.path = options.path;
    },

    parse: function(response) {
      _.each(response.persisted_resources, function(el) { el.id = el.path.join("/") });
      return response.persisted_resources;
    }

  });

  var Models = {};
  return Models = {
    PreviewFeedbackModel: PreviewFeedbackModel,
    PreviewFeedbackCollection: PreviewFeedbackCollection
  }

});